import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { compareEntities, compareEntity } from '@lycoris-nubila/ngx-lycoris';
import { isEqual, isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import {
	distinctUntilChanged,
	filter,
	map,
	shareReplay,
	tap,
} from 'rxjs/operators';

import { Document } from 'document/document';
import { DocumentState, DocumentStore } from 'document/document.store';
import { DocumentRepositoryPort } from 'document/port/document-repository.port';

import { CacheObservable } from '../../app-decorators';

@Injectable()
export class DocumentRepositoryAdapter
	extends QueryEntity<DocumentState>
	implements DocumentRepositoryPort
{
	constructor(protected store: DocumentStore) {
		super(store);
	}

	@CacheObservable()
	public observeDocument(documentId: string): Observable<Document> {
		return this.selectEntity(documentId).pipe(
			map((document) => this.store.asEntity(document)),
			distinctUntilChanged(compareEntity),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public observeDocuments(documentsId: string[]): Observable<Document[]> {
		return this.selectMany(documentsId).pipe(
			distinctUntilChanged(isEqual),
			map((documents) =>
				documents.filter(
					(doc) =>
						(doc.type != 'ANSWERS_BASIC_ASSESSMENT' &&
							doc.type != 'ANSWERS_DETAILED_ASSESSMENT') ||
						(doc.type != 'ANSWERS_BASIC_ASSESSMENT' &&
							doc.type == 'ANSWERS_DETAILED_ASSESSMENT') ||
						(documents.every((d) => d.type != 'ANSWERS_DETAILED_ASSESSMENT') &&
							doc.type == 'ANSWERS_BASIC_ASSESSMENT')
				)
			),
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public saveDocuments(entities: Document[]): void {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
